//original jquery

$(document).ready(function() {
    // ハッシュが#search-productの場合のみ動作
    if (window.location.hash === '#search-product') {
        // スクロールイベントを監視
        $(window).scroll(function() {
            var scrollPosition = $(this).scrollTop();
            var scrollThreshold = 100;

            if (scrollPosition > scrollThreshold) {
                $('.facets-container, .product-grid-container, .search-page-featured, .footer').addClass('fixed');
            } else {
                $('.facets-container, .product-grid-container, .search-page-featured, .footer').removeClass('fixed');
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // ハッシュが#search-productの場合のみ動作
    if (window.location.hash === '#search-product') {
        const detailsElement = document.querySelector('.mobile-facets__disclosure');
        const sectionHeaderElement = document.querySelector('.section-header.shopify-section-group-header-group');

        if (detailsElement) { // 要素が存在する場合のみ実行
            detailsElement.addEventListener('toggle', function() {
                if (this.open) {
                    sectionHeaderElement.style.zIndex = '1';
                } else {
                    sectionHeaderElement.style.zIndex = '5'; // 既存のz-indexに戻す場合
                }
            });
        }
    }
});
